import React from 'react'
import { FaStore, FaBoxOpen, FaCheckCircle, FaClock } from 'react-icons/fa'
import Container from './styles'

const MerchantListItem = ({ merchant }) => {
  const getStatusColor = () => {
    switch (merchant.status?.toUpperCase()) {
      case 'ACTIVE':
        return '#10b981'
      case 'INACTIVE':
        return '#f59e0b'
      case 'SUSPENDED':
        return '#ef4444'
      default:
        return '#6b7280'
    }
  }

  const formatDate = (timestamp) => {
    if (!timestamp) return 'N/A'
    const date = new Date(timestamp)
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    })
  }

  return (
    <Container statusColor={getStatusColor()}>
      <div className="merchant-header">
        <div className="merchant-icon">
          <FaStore />
        </div>
        <div className="status-badge" style={{ background: getStatusColor() }}>
          {merchant.status || 'ACTIVE'}
        </div>
      </div>
      
      <div className="merchant-info">
        <h3 className="merchant-name">{merchant.companyName || merchant.name}</h3>
        <p className="merchant-email">{merchant.email}</p>
        {merchant.phone && <p className="merchant-phone">{merchant.phone}</p>}
      </div>
      
      <div className="merchant-stats">
        <div className="stat-item">
          <FaBoxOpen className="stat-icon" />
          <span>{merchant.totalOrders || 0} Orders</span>
        </div>
        <div className="stat-item">
          <FaCheckCircle className="stat-icon" />
          <span>{merchant.completedOrders || 0} Completed</span>
        </div>
      </div>
      
      <div className="merchant-footer">
        <FaClock className="footer-icon" />
        <span>Created {formatDate(merchant.createdAt)}</span>
      </div>
    </Container>
  )
}

export default MerchantListItem
